<script setup lang="ts">
import { ref, defineEmits, defineProps, watch } from "vue";
import { useTranslate } from "@/composables/useTranslate";

type Emits = {
  (event: "onOptionUpdate", option: string[]): void;
};

type Props = {
  selectedViewOptions: string[];
};

const emits = defineEmits<Emits>();
const props = defineProps<Props>();

const tempSelectedViewOptions = ref<string[]>([...props.selectedViewOptions]);
const { t } = useTranslate();

watch(
  () => props.selectedViewOptions,
  (newVal) => {
    tempSelectedViewOptions.value = [...newVal];
  },
  { deep: true, immediate: true }
);

const onUpdateViewOpton = (option: string) => {
  if (tempSelectedViewOptions.value.includes(option)) {
    tempSelectedViewOptions.value = tempSelectedViewOptions.value.filter(
      (item) => item !== option
    );
  } else {
    tempSelectedViewOptions.value.push(option);
  }
  emits("onOptionUpdate", tempSelectedViewOptions.value);
};
</script>

<template>
  <div class="w-full border-b border-gray-200">
    <h2
      class="text-base leading-5 tracking-[0.01rem] text-primary-text-color font-semibold pb-[20px]"
    >
      {{ t("home.type_of_project") }}
      <span v-if="tempSelectedViewOptions.length > 0">
        ({{ tempSelectedViewOptions.length }})
      </span>
    </h2>
    <!-- Commercial -->
    <div class="flex gap-[8px] pb-[20px]">
      <div class="flex items-center cursor-pointer">
        <button
          @click="onUpdateViewOpton('commercial')"
          :class="[
            'px-[8px] py-[12px] rounded-[14px] text-sm',
            tempSelectedViewOptions.includes('commercial')
              ? 'bg-[#D1CFF7] text-gray-800'
              : 'bg-gray-200 text-gray-800',
          ]"
        >
          Commercial
        </button>
      </div>
      <!-- Residential -->
      <div class="flex items-center cursor-pointer">
        <button
          @click="onUpdateViewOpton('residential')"
          :class="[
            'px-[8px] py-[12px] rounded-[14px] text-sm',
            tempSelectedViewOptions.includes('residential')
              ? 'bg-[#D1CFF7] text-gray-800'
              : 'bg-gray-200 text-gray-800',
          ]"
        >
          Residential
        </button>
      </div>
    </div>
  </div>
</template>
